<template>
  <div class="log-page">
    <div class="log__header">
      <el-form :model="queryForm">
        <el-form-item :label="$t('workshopRecord.label.workNumber')"
                      class="log__header__item">
          <el-input v-model="queryForm.workNo"
                    class="operator__input"
                    clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('workshopRecord.label.name')"
                      class="log__header__item">
          <el-input v-model="queryForm.name"
                    class="operator__input"
                    clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('workshopRecord.label.applicationWorkshop')"
                      class="log__header__item">
          <el-input v-model="queryForm.workShopName"
                    class="operator__input"
                    clearable></el-input>
        </el-form-item>
        <el-form-item class="log__header__item log__header__operator__btn">
          <el-button type="primary"
                     @click="queryList({pageSize:pageSize, pageNum:currentPage})">{{ $t('workshopRecord.button.query') }}</el-button>
          <el-button type="info"
                     @click="formClear({pageSize:pageSize, pageNum:currentPage})">{{ $t('workshopRecord.button.reset') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="log__context">
      <el-table :data="carApprovalDatas"
                style="width: 100%;"
                stripe
                height="100%">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <!-- <el-table-column type="index" :index="indexMethod" :label="$t('workshopRecord.label.jobNumber')" width="60px"></el-table-column> -->
        <el-table-column prop="name"
                         :show-overflow-tooltip="true"
                         align="center"
                         :label="$t('workshopRecord.label.name')"></el-table-column>
        <el-table-column prop="workNo"
                         align="center"
                         :show-overflow-tooltip="true"
                         :label="$t('workshopRecord.label.workNumber')"></el-table-column>
        <el-table-column prop="phone"
                         :show-overflow-tooltip="true"
                         align="center"
                         :label="$t('workshopRecord.label.phone')"></el-table-column>
        <el-table-column prop="workShopNames"
                         align="center"
                         :show-overflow-tooltip="true"
                         :label="$t('workshopRecord.label.applicationWorkshop')"></el-table-column>
        <el-table-column prop="enterTime"
                         align="center"
                         :show-overflow-tooltip="true"
                         :label="$t('workshopRecord.label.entryTime')"></el-table-column>
        <el-table-column prop="exitTime"
                         align="center"
                         :show-overflow-tooltip="true"
                         :label="$t('workshopRecord.label.leaveTime')"></el-table-column>
        <el-table-column prop="visitorReason"
                         :show-overflow-tooltip="true"
                         align="center"
                         :label="$t('workshopRecord.label.desc')"></el-table-column>
        <el-table-column prop="status"
                         :show-overflow-tooltip="true"
                         align="center"
                         :label="$t('workshopRecord.label.status')">
          <template slot-scope="scope">
            <span v-if="scope.row.status==='1'"
                  style="color: yellow; cursor: pointer;"
                  @click="showDetails(scope.row)">{{statusFormatter(scope.row)}}</span>
            <span v-if="scope.row.status==='2'"
                  style="color: #00e8bb; cursor: pointer;"
                  @click="showDetails(scope.row)">{{statusFormatter(scope.row)}}</span>
            <span v-if="scope.row.status==='3'"
                  style="color: red; cursor: pointer;"
                  @click="showDetails(scope.row)">{{statusFormatter(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         :label="$t('workshopRecord.label.operations')">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content="$t('workshopRecord.button.detail')"
                        placement="top"
                        popper-class="tooltip-draw">
              <el-button @click="showDetails(scope.row)"
                         icon="iconfont icon-Detail"
                         type="text"
                         size="small"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty">
            <img src="@/common/assets/images/empty.svg" />
            <p>{{$t('base.label.empty')}}</p>
          </div>
        </template>
      </el-table>
      <el-pagination class="mt30 mb20 page-layer"
                     background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="pageSize"
                     :total="total"
                     :pageNum="1"
                     :current-page="currentPage"
                     @size-change="sizeChange"
                     @current-change="pageChange"
                     @prev-click="pageChange"
                     @next-click="pageChange" />
    </div>
    <el-dialog :title="$t('workshopRecord.title.detail')"
               :visible.sync="logDialogVisible"
               v-dialogDrag
               width="600px"
               class="log-detail">
      <el-row>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.name') }}: {{details.name}}</label>
        </el-col>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.workNumber') }}: {{details.workNo}}</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.phone') }}: {{details.phone}}</label>
        </el-col>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.applicationWorkshop') }}: {{details.workShopNames}}</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.entryTime') }}: {{details.enterTime}}</label>
        </el-col>
        <el-col :span="12">
          <label>{{ $t('workshopRecord.label.leaveTime') }}: {{details.exitTime}}</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <label>{{ $t('workshopRecord.label.desc') }}: {{details.visitorReason}}</label>
        </el-col>
      </el-row>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="text"
                   class="iss-reset-button"
                   @click="close">{{ $t('workshopRecord.button.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@src/common/utils'
import { Dic, Cache, Bus, Base, Dates } from "$utils";
import { getDatas } from "../service/service";
import { formatTimeToStr } from "../filter/dateUtils";
export default {
  name: "SecurityShift",
  data () {
    return {
      logDialogVisible: false,
      queryForm: {
        workNo: "",
        name: "",
        workShopName: "",
      },
      // 缓存表单数据
      formCacheLabelAlign: {
        workNo: "",
        name: "",
        workShopName: "",
      },
      pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      total: 10,
      currentPage: 0,
      carApprovalDatas: [],
      details: {},
    };
  },
  mounted () {
    const self = this;
    const loading = self.$loading({
      lock: true,
      text: '请求中',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    getDatas({
      self: this,
      caller: function (rep) {
        setTimeout(() => {
          loading.close()
        }, 500);
        if (!rep.success) {
          // 表示请求失败
          self.$message.error(rep.msgContent);
        } else {
          if (rep.returnObj != null) {
            self.total = rep.returnObj.total;
            self.currentPage = rep.returnObj.pageNum;
            // self.pageSize = rep.returnObj.pageSize;
            self.carApprovalDatas = rep.returnObj.list;
          }
        }
      },
    });
  },
  methods: {
    getImgPath (item) {
      return item ? Bus.imgPath(item) : "";
    },
    indexMethod (index) {
      return this.pageSize * (this.currentPage - 1) + index + 1;
    },
    statusFormatter (data) {
      switch (data.status * 1) {
        // 1:待接待人审批,2:接待人审批通过,待部门负责人审批3:部门负责人审批通过,待区域负责人审批4:区域负责人同意5:拒绝'
        case 1:
          return "待审批";
        case 2:
          return "已通过";
        case 3:
          return "已拒绝";
        default:
          return data.status;
      }
    },
    vehicleTypeFormatter (row) {
      return Dic.findByValue("SENU038", row.vehicleType);
    },
    vehicleColorFormatter (row) {
      return Dic.findByValue("SENU039", row.vehicleColor);
    },
    showDetails (row) {
      this.details = row;
      this.logDialogVisible = true;
    },
    // 重置查询条件
    formClear ({ pageSize = utils.Cache.get('CURRENT_PAGESIZE') || 10, pageNum = 1 }) {
      this.queryForm = {
        workNo: "",
        name: "",
        workShopName: "",
      };
      this.formCacheLabelAlign = {
        workNo: "",
        name: "",
        workShopName: "",
      };
      this.currentPage = 1;
      // this.pageSize = 10;
      const param = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      this.search(param);
    },
    queryList ({ pageSize = this.pageSize, pageNum = this.currentPage }) {
      this.currentPage = 1;
      this.formCacheLabelAlign = this.queryForm;
      const param = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      this.search(param);
    },
    search ({ pageSize = this.pageSize, pageNum = this.currentPage }) {
      const self = this;
      const item = self.formCacheLabelAlign;
      const param = {};
      param.workNo = item.workNo;
      param.name = item.name;
      param.workShopName = item.workShopName;
      param.pageSize = pageSize ? pageSize : 10;
      param.pageNum = pageNum ? pageNum : 1;
      param.self = self;
      const loading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      param.caller = function (rep) {
        setTimeout(() => {
          loading.close()
        }, 500);
        if (!rep.success) {
          // 表示请求失败
          self.$message.error(rep.msgContent);
        } else {
          if (rep.returnObj != null) {
            self.total = rep.returnObj.total;
            self.currentPage = rep.returnObj.pageNum;
            // self.pageSize = rep.returnObj.pageSize;
            self.carApprovalDatas = rep.returnObj.list;
          }
        }
      };

      getDatas(param);
    },
    sizeChange (pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.search({ pageSize: this.pageSize, pageNum: this.currentPage });
    },
    pageChange (pageNum) {
      this.currentPage = pageNum;
      this.search({ pageNum: this.currentPage, pageSize: this.pageSize });
    },
    close () {
      this.logDialogVisible = false;
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "../css/css.scss";
.logDeatils {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
}
</style>
<style>
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 5px 0;
  /* height: 50px; */
  margin-top: 10px;
}
.el-table--scrollable-y .el-table__body-wrapper {
  height: calc(48vh);
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.log-page {
  width: 100%;
  height: 100%;
  .log__header .el-form-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    .el-form-item__content {
      .operator__input {
        width: 65%;
      }
      .el-range-editor--mini.el-input__inner {
        width: 85%;
      }
      .el-date-editor .el-range-separator {
        padding: 0px;
      }
    }
  }
  .log-page {
    .el-dialog__header {
      // @include set_theme_color(background-color, main-content-bg-color);
      background-color: rgba(56, 63, 110, 1);
      height: 40px;
      padding: 0px;
      span {
        line-height: 40px;
        margin-left: 20px;
      }
      button {
        top: 12px;
      }
    }
    .el-dialog__body {
      // @include set_theme_color(background-color, dialog-main-bg-color);
      color: #fff;
      .el-row {
        margin-bottom: 20px;
      }
    }
    .el-dialog__footer {
      // @include set_theme_color(background-color, main-content-bg-color);
      background-color: rgba(56, 63, 110, 1);
      height: 40px;
      padding-top: 7px;
    }
  }
  .log__context {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
